const hotProductList = ["D10A", "D20A", "D30A"];
const productTypeList = [
  { name: "黑白打印机", children: ["D10A", "D10B", "D10C", "D10D", "D10E"] },
  { name: "彩色打印机", children: ["D20A", "D20B", "D30A"] },
  { name: "桌面型打印机", children: ["D30A"] },
  {
    name: "高校场景打印机",
    children: ["D10A", "D10B", "D10C", "D10D", "D10E", "D20A", "D20B"]
  },
  { name: "便民场景打印机", children: ["D30A"] },
  {
    name: "照片功能打印机",
    children: ["D20A", "D20B", "D30A"]
  },
  { name: "多拉宝盒", children: ["多拉宝盒"] }
];
const productList = [
  {
    id: "D10A",
    listSrc: require("@/assets/product/list_D10A.png"),
    detailSrc: require("@/assets/product/detail_D10A.png"),
    descArr: [
      "多拉自助云打印终端占地不足一平米，自带4G网络，可实现高速打印体验。",
      "用户可通过微信公众号、微信小程序、U盘、PC端等移动端将需要打印的文件传输到附近任意的多拉智能云打印终端，实现随时随地、自由打印。",
      "多拉在整个自助打印过程中文件自动加密，24H系统自动删除并粉碎，再次确保文件防泄密事情发生，选择多拉自助打印设备特点是：安全、便捷、优惠、操作简单、7*24小时服务等诸多优点。"
    ],
    contentArr: [
      "基本属性：支持黑白/单面/双面多模式混合打印，打印速度约40页/分钟。",
      "基本配置：一台激光打印机，两个520页附加纸盒（存储纸张：A4 1290张），一个多拉宝盒，一个华为4G路由器，一个公牛插线板等。",
      "综合功耗：打印模式32W，待机模式1.2W。",
      "设备尺寸：500mm*500mm*1050mm"
    ]
  },
  {
    id: "D10B",
    listSrc: require("@/assets/product/list_D10A.png"),
    detailSrc: require("@/assets/product/detail_D10A.png"),
    descArr: [
      "多拉自助云打印终端占地不足一平米，自带4G网络，可实现高速打印体验。",
      "用户可通过微信公众号、微信小程序、U盘、PC端等移动端将需要打印的文件传输到附近任意的多拉智能云打印终端，实现随时随地、自由打印。",
      "多拉在整个自助打印过程中文件自动加密，24H系统自动删除并粉碎，再次确保文件防泄密事情发生，选择多拉自助打印设备特点是：安全、便捷、优惠、操作简单、7*24小时服务等诸多优点。"
    ],
    contentArr: [
      "基本属性：支持黑白/单面/双面多模式混合打印，打印速度约40页/分钟。",
      "基本配置：一台激光打印机，一个520页附加纸盒。（存储纸张：A4 770张）一个多拉宝盒，一个华为4G路由器，一个公牛插线板等。",
      "综合功耗：打印模式32W，待机模式1.2W。",
      "设备尺寸：500mm*500mm*1050mm"
    ]
  },
  {
    id: "D10C",
    listSrc: require("@/assets/product/list_D10A.png"),
    detailSrc: require("@/assets/product/detail_D10A.png"),
    descArr: [
      "多拉自助云打印终端占地不足一平米，自带4G网络，可实现高速打印体验。",
      "用户可通过微信公众号、微信小程序、U盘、PC端等移动端将需要打印的文件传输到附近任意的多拉智能云打印终端，实现随时随地、自由打印。",
      "多拉在整个自助打印过程中文件自动加密，24H系统自动删除并粉碎，再次确保文件防泄密事情发生，选择多拉自助打印设备特点是：安全、便捷、优惠、操作简单、7*24小时服务等诸多优点。"
    ],
    contentArr: [
      "基本属性：支持黑白/单面/双面多模式混合打印，打印速度约33页/分钟。",
      "基本配置：一台激光打印机，一个550页附加纸盒（存储纸张：A4 800张），一个多拉宝盒，一个华为4G路由器，一个公牛插线板等。",
      "综合功耗：打印模式31W，待机模式1.1W。",
      "设备尺寸：500mm*500mm*1050mm"
    ]
  },
  {
    id: "D10D",
    listSrc: require("@/assets/product/list_D10D.png"),
    detailSrc: require("@/assets/product/detail_D10D.png"),
    descArr: [
      "多拉自助云打印终端占地不足一平米，自带4G网络，可实现高速打印体验。",
      "用户可通过微信公众号、微信小程序、U盘、PC端等移动端将需要打印的文件传输到附近任意的多拉智能云打印终端，实现随时随地、自由打印。",
      "多拉在整个自助打印过程中文件自动加密，24H系统自动删除并粉碎，再次确保文件防泄密事情发生，选择多拉自助打印设备特点是：安全、便捷、优惠、操作简单、7*24小时服务等诸多优点。"
    ],
    contentArr: [
      "基本属性：支持黑白/单面/双面多模式混合打印，打印速度约33页/分钟。",
      "基本配置：一台激光打印机，两个520页附加纸盒（存储纸张：A4 1290张），一台工业触屏一体机，一个华为4G路由器，一个公牛插线板等。",
      "综合功耗：打印模式152W，待机模式21.2W。综合功耗：打印模式152W，待机模式21.2W。",
      "设备尺寸：500mm*500mm*1050mm"
    ]
  },
  {
    id: "D10E",
    listSrc: require("@/assets/product/list_D10E.png"),
    detailSrc: require("@/assets/product/detail_D10E.png"),
    descArr: [
      "多拉自助云打印终端占地不足一平米，自带4G网络，可实现高速打印体验。",
      "用户可通过微信公众号、微信小程序、U盘、PC端等移动端将需要打印的文件传输到附近任意的多拉智能云打印终端，实现随时随地、自由打印。",
      "用户可通过微信公众号、微信小程序、U盘、PC端等移动端将需要打印的文件传输到附近任意的多拉智能云打印终端，实现随时随地、自由打印。"
    ],
    contentArr: [
      "基本属性：支持黑白/单面/双面多模式混合打印，打印速度约33页/分钟。",
      "基本配置：一台激光打印机，两个520页附加纸盒（存储纸张：A4 1290张），一台工业触屏一体机，一个华为4G路由器，一个公牛插线板等。",
      "综合功耗：打印模式152W，待机模式21.2W。",
      "设备尺寸：500mm*500mm*1050mm"
    ]
  },
  {
    id: "D20A",
    listSrc: require("@/assets/product/list_D10A.png"),
    detailSrc: require("@/assets/product/detail_D10A.png"),
    descArr: [
      "多拉自助云打印终端占地不足一平米，自带4G网络，可实现高速打印体验。",
      "用户可通过微信公众号、微信小程序、U盘、PC端等移动端将需要打印的文件传输到附近任意的多拉智能云打印终端，实现随时随地、自由打印。",
      "多拉在整个自助打印过程中文件自动加密，24H系统自动删除并粉碎，再次确保文件防泄密事情发生，选择多拉自助打印设备特点是：安全、便捷、优惠、操作简单、7*24小时服务等诸多优点。"
    ],
    contentArr: [
      "基本属性：支持黑白/彩色/单面/双面多模式混合打印，打印速度约34页/分钟。",
      "基本配置：一台喷墨打印机，一个550页附加纸盒（存储纸张：A4 800张、相纸 20张），一个多拉宝盒，一个华为4G路由器，一个公牛插线板等。",
      "综合功耗：打印模式约22W，待机模式约1.2W。",
      "设备尺寸：500mm*500mm*1050mm"
    ]
  },
  {
    id: "D20B",
    listSrc: require("@/assets/product/list_D10A.png"),
    detailSrc: require("@/assets/product/detail_D10A.png"),
    descArr: [
      "多拉自助云打印终端占地不足一平米，自带4G网络，可实现高速打印体验。",
      "用户可通过微信公众号、微信小程序、U盘、PC端等移动端将需要打印的文件传输到附近任意的多拉智能云打印终端，实现随时随地、自由打印。",
      "多拉在整个自助打印过程中文件自动加密，24H系统自动删除并粉碎，再次确保文件防泄密事情发生，选择多拉自助打印设备特点是：安全、便捷、优惠、操作简单、7*24小时服务等诸多优点。"
    ],
    contentArr: [
      "基本属性：支持黑白/彩色/单面/双面多模式混合打印，打印速度约34页/分钟。",
      "基本配置：一台喷墨打印机（存储纸张：A4 500张、相纸 100张），一个多拉宝盒，一个华为4G路由器，一个公牛插线板等。",
      "综合功耗：打印模式约22W，待机模式约1.2W。",
      "设备尺寸：500mm*500mm*1050mm"
    ]
  },
  {
    id: "D30A",
    listSrc: require("@/assets/product/list_D30A.png"),
    detailSrc: require("@/assets/product/detail_D30A.png"),
    descArr: [
      "多拉自助云打印终端占地不足一平米，自带4G网络，可实现高速打印体验。",
      "用户可通过微信公众号、微信小程序、U盘、PC端等移动端将需要打印的文件传输到附近任意的多拉智能云打印终端，实现随时随地、自由打印。",
      "多拉在整个自助打印过程中文件自动加密，24H系统自动删除并粉碎，再次确保文件防泄密事情发生，选择多拉自助打印设备特点是：安全、便捷、优惠、操作简单、7*24小时服务等诸多优点。"
    ],
    contentArr: [
      "基本属性：支持黑白/彩色/单面/双面多模式混合打印，打印速度约13页/分钟。",
      "基本配置：一台喷墨打印机（存储纸张：A4 250张、相纸 30张），一个多拉宝盒，一个华为4G路由器，一个公牛插线板等。",
      "综合功耗：打印模式约21W，待机模式约0.8W。",
      "设备尺寸：369mm*403mm*166mm"
    ]
  },
  {
    id: "多拉宝盒",
    listSrc: require("@/assets/product/list_baohe.png"),
    detailSrc: require("@/assets/product/detail_baohe.png"),
    descArr: [
      "自主研发设计的一款智能安全打印服务器终端，适配多种市场主流打印机型号。多拉宝盒特点是：尺寸更小，功能更强大，微电子工艺技术，即插即用等诸多优点。"
    ],
    contentArr: [
      "基本属性：自助云打印服务器。体积小，性能高。",
      "基本配置：千兆网口，USB3.0，USB-C供电口，支持有线/无线两种连接方式。",
      "供电要求：5V2A",
      "设备尺寸：58mm*58mm*27mm"
    ]
  }
];

export { hotProductList, productList, productTypeList };
